<template>
  <v-flex>
    <v-btn
      color="secondary darken-2 px-4 mt-5"
      v-for="item in activeRoutes"
      :key="item.title" 
      :to="item.to"
      dark
      v-text="item.title"
    />
  </v-flex>
</template>

<script>
export default {
  data() {
    return {
      routes: [
        { title: "student", to: "student" },
        { title: "Staff", to: "staff" },
        { title: "Academic", to: "academic" },
        { title: "Organisation", to: "organisation" },
        { title: "Admin", to: "admin" }
      ]
    };
  },
  computed: {
    activeRoutes() {
      return this.routes.filter(u => {
        return this.user && this.user[u.to];
      });
    },
    user() {
      return this.$store.getters.user;
    }
  }
};
</script>
